<script setup>
  import {useUserStore} from "@/stores/user";
  
  const userStore = useUserStore();
</script>

<template>
  <footer>
    <div class="container">
      <div class="d-flex flex-wrap justify-content-between my-4 fs-6">
        <div v-if="userStore.isIm() && !userStore.isPanelIFrame()" class="text-n700">
          Copyright © {{ new Date().getFullYear() }} insurancemarket.gr | Version: {{ version }}
        </div>
        <div class="d-flex flex-wrap">
          <div class="link-item text-n700">
            <a
              class="footer-link"
              href="/privacy"
              target="_blank"
            >Πολιτική Απορρήτου</a
            >
          </div>
          <div class="link-item text-n700">
            <a class="footer-link"
              :href = "userStore.isIm() ? '/terms' : '/terms-and-conditions'"
              target="_blank"
            >Όροι Χρήσης</a
            >
          </div>
          <div class="link-item text-n700">
            <a
              class="footer-link"
              href="/cookie-policy"
              target="_blank"
            >Πολιτική Cookies</a
            >
          </div>
        </div>
      </div>
      <div v-if="userStore.isIm() && !userStore.isPanelIFrame()" class="py-4 fs-6 text-n700 mb-4 border-2 border-top border-bottom">
        Το insurancemarket.gr αναπτύχθηκε από την Money Market Α.Ε. με Α.Φ.Μ 998940997/ΚΕΦΟΔΕ ΑΤΤΙΚΗΣ και αριθμό ΓΕΜΗ 006784301000, που εδρεύει επί της οδού Πύρρας 4, Νέος Κόσμος, 11745 και έχει νομίμως καταχωρηθεί στο Μητρώο του Επαγγελματικού Επιμελητηρίου Αθηνών ως ασφαλιστικός πράκτορας με αριθμό μητρώου 6584 και ως συντονιστής ασφαλιστικών πρακτόρων με αριθμό μητρώου 1056. Τα ανωτέρω στοιχεία μπορείτε να τα επιβεβαιώσετε από το σύνδεσμο του <a href="https://insuranceregistry.uhc.gr/">Ενιαίου Σημείου Πληροφόρησης</a>
      </div>
    </div>
    <!-- build version -->
  </footer>
</template>
